export const actions = {
    push({ commit }, { event, ecommerce }) {
        setTimeout(() => {
            this.$gtm.push({ event: event, ecommerce: ecommerce});
        }, 5000);
    },
};
